import { Component, EventEmitter, OnDestroy, OnInit } from "@angular/core";
import { FieldType } from "@ngx-formly/core";
import { Observable, of, Subject } from "rxjs";
import {
  takeUntil,
  startWith,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  filter,
  catchError,
  map,
  tap,
} from "rxjs/operators";
import { NgSelectComponent } from "@ng-select/ng-select";

@Component({
  selector: "formly-field-typeahead",
  template: `
    <!-- <label>{{field.templateOptions.label}}</label> -->

    <ng-select
      [items]="options$ | async"
      [typeahead]="search$"
      [formControl]="formControl"
      [placeholder]="field.templateOptions.placeholder"
      aria-label="{{ field.templateOptions.placeholder }}"
      [multiple]="field.templateOptions.multi"
      bindLabel="{{ field.templateOptions.bindLabel }}"
      bindValue="{{ field.templateOptions.bindValue }}"
      dropdownPosition="bottom"
    >
    </ng-select>
  `,
  // styleUrls: ['./typeahead.type.component.scss'],
})
export class FormlyFieldTypeahead extends FieldType implements OnDestroy, OnInit {
  onDestroy$ = new Subject<void>();
  search$ = new EventEmitter();
  options$: Observable<any> = of([]);

  ngOnInit() {
    console.log(this.formControl);
    this.options$ = this.search$.pipe(
      takeUntil(this.onDestroy$),
      startWith(""),
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(term => {
        // console.log("Termine cercato:", term);
        if (typeof this.to.search$ !== "function") {
          // console.error("Errore: this.to.search$ non è una funzione", this.to.search$);
          return of([]);
        }

        return this.to.search$(term).pipe(
          // tap(response => console.log("Dati ricevuti dalla ricerca:", response)),
          map(response => {
            if (!Array.isArray(response)) {
              // console.warn("Typeahead sta ricevendo un valore non valido, lo resetto:", response);
              return [];
            }
            return response;
          }),
          catchError(err => {
            // console.error("Errore API:", err);
            return of([]); // Restituisci array vuoto in caso di errore
          })
        );
      })
    );
    // this.options$.subscribe();
  }

  ngOnDestroy() {
    this.onDestroy$.complete();
  }
}
